import { useDispatch } from "react-redux";
import { MAIN_ROUTE } from "../../static/vars";
import { useNavigate } from "react-router-dom";

export function StepThree() {
    const navigate = useNavigate()

    return (
        <div class="one-ekran-contant-lending-step one-ekran-contant-lending-step-3" style={{ display: 'block' }}>
            {/* <p class="lending-step-text">Заполни форму и получи 3% дополнительной скидки.
                Ваша страховка будет продлена вовремя!</p> */}
            <label for="select-1">Мы получили ваш запрос, наш менеджер уже подбирает лучший вариант.<br/> Если вы не готовы ждать, можете 
            оформить полис на нашем сайте самостоятельно.</label>
            {/* <form class="form-popup form-popup-2">
                <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-15">
                    <label for="select-1">Ваше имя</label>
                    <input class="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Имя" type="text" placeholder="-" required="" />
                </div>
                <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-16">
                    <label for="select-1">Телефон</label>
                    <input class="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Адрес" type="text" placeholder="+7" required="" />
                </div>
                <div class="one-ryad one-ryad-popup one-ryad-popup-3  one-ryad-popup-user one-ryad-popup-user-17">
                    <div class="form-group">
                        <div class="dropdown">
                            <label for="select-1">Месяц продления страховки</label>
                            <button class="dropdown__button dropdown__button-popup dropdown__button-popup-user">декабрь
                                2023</button>
                            <ul class="dropdown__list dropdown__list-calc">
                                <li class="dropdown__list-item" data-value="декабрь 2023">декабрь 2023</li>
                                <li class="dropdown__list-item" data-value="январь 2024">январь 2024</li>
                                <li class="dropdown__list-item" data-value="февраль 2024">февраль 2024</li>
                                <li class="dropdown__list-item" data-value="март 2024">март 2024</li>
                                <li class="dropdown__list-item" data-value="апрель 2024">апрель 2024</li>
                                <li class="dropdown__list-item" data-value="май 2024">май 2024</li>
                                <li class="dropdown__list-item" data-value="июнь 2024">июнь 2024</li>
                                <li class="dropdown__list-item" data-value="июль 2024">июль 2024</li>
                                <li class="dropdown__list-item" data-value="август 2024">август 2024</li>
                                <li class="dropdown__list-item" data-value="сентябрь 2024">сентябрь 2024</li>
                                <li class="dropdown__list-item" data-value="октябрь 2024">октябрь 2024</li>
                                <li class="dropdown__list-item" data-value="ноябрь 2024">ноябрь 2024</li>
                                <li class="dropdown__list-item" data-value="декабрь 2024">декабрь 2024</li>
                            </ul>
                            <input type="text" name="select-category" value="" class="dropdown__input-hidden" />
                        </div>
                    </div>
                </div>
                <div class="checkbox-1-3-box">
                    <input class="checkbox-1 checkbox-1-3" type="checkbox" id="scales" name="zakon" value="" onKeyUp="displaySubmit()" checked="" />
                    <label for="scales">Принимаю правила страхования</label>
                </div>
                <a href="#header" class="button button-1 button-popup-1 button-lending-3">Отправить</a>
            </form> */}
            <div onClick={() => navigate(MAIN_ROUTE + '/', { replace: true })} class="button button-1 button-popup-1 button-lending-3">Оформить полис</div>
        </div>
    )
}
